import { Component, Input } from '@angular/core';
import { BaseAreaAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-details-extra-measures',
  templateUrl: './area-details-extra-measures.component.html',
  styleUrls: ['./area-details-extra-measures.component.scss'],
})
export class AreaDetailsExtraMeasuresComponent extends BaseAreaAccordionComponent {
  @Input() area;
  @Input() isEditingDisabled = false;

  constructor(accordionService: AccordionService) {
    super(accordionService);
  }
}
